import { metaData } from '@cornerstonejs/core';
export function fetchPaletteData(imageFrame, color, fallback) {
    const data = imageFrame[`${color}PaletteColorLookupTableData`];
    if (data) {
        return Promise.resolve(data);
    }
    const result = metaData.get('imagePixelModule', imageFrame.imageId);
    if (result && typeof result.then === 'function') {
        return result.then((module) => module ? module[`${color}PaletteColorLookupTableData`] : fallback);
    }
    else {
        return Promise.resolve(result ? result[`${color}PaletteColorLookupTableData`] : fallback);
    }
}
